import { render, staticRenderFns } from "./MediaInfoList.vue?vue&type=template&id=979399ca"
import script from "./MediaInfoList.vue?vue&type=script&lang=js"
export * from "./MediaInfoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports